export default "__VITE_ASSET__IxG8hbK0__"